import { useMemo } from 'react';
import useMySelectionCollection, {
  type IUseMySelectionCollectionValue,
} from '@/creditflowresearch/ui/common/hooks/useMySelectionCollection';
import useGroupSyncState, {
  type IUseGroupSyncStateValue,
} from '@/creditflowresearch/ui/common/hooks/useGroupSyncState';
import type { ICorporateBondScreenerTrancheRow } from './useCorporateBondScreener';

export type ICorporateBondScreenerMySelectionValue =
  IUseMySelectionCollectionValue<ICorporateBondScreenerTrancheRow> & IUseGroupSyncStateValue;

export const getTrancheId = (item: ICorporateBondScreenerTrancheRow): string => item.id;

const useCorporateBondScreenerMySelection = (): ICorporateBondScreenerMySelectionValue => {
  const collection = useMySelectionCollection<ICorporateBondScreenerTrancheRow>(getTrancheId);
  const sync = useGroupSyncState();

  return useMemo(() => ({ ...collection, ...sync }), [collection, sync]);
};

export default useCorporateBondScreenerMySelection;
